/** An object of Elevio module IDs mapped to Dixa features. */
export const modules = {
  autocomplete: {
    giveFeedback: 40,
  },
};

/** An object of Elevio article IDs mapped to Dixa features. */
export const articles = {
  analytics: {
    quickViews: '1442',
    advancedFilters: '1588',
    businessHours: '1669',
  },
  dashboard: {
    queues: {
      documentation: '1754',
    },
    channels: {
      documentation: '1812',
    },
    favorites: {
      documentation: '2126',
    },
  },
  search: {
    documentation: '57',
  },
  settings: {
    profile: {
      keyboardShortcuts: '128',
    },
    preferences: {
      darkMode: '1966',
    },
    messenger: {
      userIdentityTooltip: '1098',
      customLauncherIconTooltipId: '1307',
      elevioIntegrationTooltip: '1336',
    },
    thirdPartyMessaging: {
      whatsapp: { howToSetupDocs: '176' },
      facebookMessenger: { howToSetupDocs: '1023' },
      instagram: { howToSetupDocs: '725' },
    },
    businessHours: {
      announcement: '1106',
    },
    scheduledConversations: {
      documentation: '222',
    },
    chatbots: {
      documentation: '1504',
      mim: {
        identityAndPersona: {
          documentation: '1949',
        },
        tools: {
          documentation: '1992',
          overview: '1915',
        },
        platformActions: {
          documentation: '2118',
        },
        procedures: {
          documentation: '2089',
        },
        tasks: {
          documentation: '1915',
          outputs: '1912',
        },
        handoffs: {
          documentation: '1930',
        },
        customInstructions: {
          documentation: '1934',
        },
        test: {
          documentation: '2008',
          deployment: '1727',
        },
      },
    },
    cards: {
      custom: '216',
      shopify: '93',
      salesforce: '123',
      magento: '182',
    },
    webformEndpoints: {
      documentation: '175',
    },
    exportConversations: {
      documentation: '12',
    },
    queues: {
      archiving: '1649',
    },
    busyLight: '95',
    partners: {
      widget: {
        braze: '1865',
        github: '1670',
        jira: '1379',
        klaviyo: '1667',
        linear: '1622',
        loyaltylion: '1801',
        recharge: '1845',
        shopify: '1205',
        voyado: '1731',
        yotpo: '1879',
        ingrid: '2094',
        rivoloyalty: '2142',
      },
      dataSync: {
        assembled: '2061',
      },
    },
    customAttributes: {
      documentation: {
        conversation: '1455',
        contact: '1758',
      },
    },
    customForms: {
      documentation: '1862',
      webformsIntegration: {
        documentation: '175',
      },
    },
    webhooks: '1871',
    sla: {
      documentation: '2002',
    },
    flows: {
      advancedExpressions: '2130',
    },
  },
  conversations: {
    summaryByAI: '1616',
  },
};

/** An object of Elevio categories IDs mapped to Dixa features. */
export const categories = {
  settings: {
    integrations: {
      documentation: '26',
    },
  },
};
